import { makeStyles, Theme } from "@material-ui/core";

import { UserRole } from "modules/user/types/entities";

import { roleColors } from "../../../utils/constants";

export const useRoleChipStyles = makeStyles<Theme, { role?: UserRole }>(
  theme => ({
    chip: {
      color: ({ role }) =>
        role ? roleColors[role] : theme.palette.secondary.main,
      borderColor: ({ role }) => (role ? roleColors[role] : undefined),
      borderRadius: 20,
      height: 24,
      padding: 0,
      fontWeight: 500,
      cursor: "inherit",
      width: 160
    }
  })
);
